module.exports = __webpack_public_path__ + "img/profiling_illustration.767c653e.svg";